import React from 'react'
import styled from 'styled-components'
import ReactSlider from 'react-slider'

export const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 6px;
  margin-top: 25px;
`

export const StyledThumb = styled.div`
  height: 22px;
  line-height: 22px;
  width: 22px;
  text-align: center;
  background-color: #fff;
  color: #fff;
  border-radius: 50px;
  cursor: grab;
  top: -9px;
  border: 2px solid #19b3ff;
  box-sizing: border-box;
`

export const ReactSliderStyledThumb = styled.div`
  height: 22px;
  line-height: 22px;
  width: 22px;
  text-align: center;
  background-color: #fff;
  color: #fff;
  border-radius: 50px;
  cursor: grab;
  top: -9px;
  border: 2px solid #96c90a !important;
  box-sizing: border-box;
`

export const ReactSliderStyledTrack = styled.div`
  //key: electricTrack;
  //orientation: landscape;
  top: 0;
  bottom: 0;
  background: ${(props: { index: number }) => (props.index === 1 ? '#BDBDBD' : '#96C90A')};
  border-radius: 999px;
`

export const StyledTrack = styled.div`
  //key: electricTrack;
  //orientation: landscape;
  top: 0;
  bottom: 0;
  background: ${(props: { index: number }) =>
    props.index === 2 ? '#19B3FF' : props.index === 1 ? '#870058' : '#BDBDBD'};
  border-radius: 999px;
`

export const Track = (props: any, state: any) => <StyledTrack {...props} index={state.index} />
export const Thumb = (props: any) => <StyledThumb {...props} />
export const ReactSliderTrack = (props: any, state: any) => (
  <ReactSliderStyledTrack {...props} index={state.index} />
)
export const ReactSliderThumb = (props: any) => <ReactSliderStyledThumb {...props} />
